//
// disable frequency fields if respective property is not filled
//

var ToggleAccordionButtons = (function () {
    'use strict';

    var inputs = document.querySelectorAll('input');

    // get the selector of the frequency dropdown for the field
    function getDropdownSelector(inputName) {
        return `select[name='${inputName}_frequency']`;
    }

    function enableFrequency(name) {
        var select = $(getDropdownSelector(name));
        // enable the field
        select.removeAttr("disabled");

        // show the asterisk
        select.closest(".form-group").find("sup.text-danger").show();
    }

    function disableFrequency(name) {
        var select = $(getDropdownSelector(name));
        // disable the field
        select.attr("disabled", "disabled");

        // remove asterisk
        select.closest(".form-group").find("sup.text-danger").hide();

        // clean up old value
        select.val("");

        // hide error message if shown
        var errorMessageId = select.attr("aria-describedby");
        $(`#${errorMessageId}`).hide();
    }


    function init() {
        for (var input of inputs) {
            var inputName = $(input).attr("name");
            var select = $(getDropdownSelector(inputName));
            
            if (select.length) {
                disableFrequency(name);

                $(input).on("keyup change paste", function () {
                    var currentName = $(this).attr("name");

                    if ($(this).val()) {
                        enableFrequency(currentName);
                    } else {
                        disableFrequency(currentName);
                    }
                });
            }
        }
    }


    for (var input of inputs) {
        var inputName = $(input).attr("name");
        var select = $(getDropdownSelector(inputName));
        select.attr("disabled", "disabled");
    }

    if (inputs.length) {
        init();
    }
})();
